import {
  LIST_SERVICE_DOMAIN_REQUEST,
  LIST_SERVICE_DOMAIN_SUCCESS,
  LIST_SERVICE_DOMAIN_FAIL,
  CREATE_SERVICE_DOMAIN_REQUEST,
  CREATE_SERVICE_DOMAIN_SUCCESS,
  CREATE_SERVICE_DOMAIN_FAIL,
  DETAIL_SERVICE_DOMAIN_SERVICE_REQUEST,
  DETAIL_SERVICE_DOMAIN_SERVICE_SUCCESS,
  DETAIL_SERVICE_DOMAIN_SERVICE_FAIL,
  DETAIL_SERVICE_DOMAIN_REQUEST,
  DETAIL_SERVICE_DOMAIN_SUCCESS,
  DETAIL_SERVICE_DOMAIN_FAIL,
  UPDATE_SERVICE_DOMAIN_REQUEST,
  UPDATE_SERVICE_DOMAIN_SUCCESS,
  UPDATE_SERVICE_DOMAIN_FAIL,
  UPDATE_SERVICE_DOMAIN_SERVICE_REQUEST,
  UPDATE_SERVICE_DOMAIN_SERVICE_SUCCESS,
  UPDATE_SERVICE_DOMAIN_SERVICE_FAIL,
  DELETE_SERVICE_DOMAIN_REQUEST,
  DELETE_SERVICE_DOMAIN_SUCCESS,
  DELETE_SERVICE_DOMAIN_FAIL,
  DELETE_SERVICE_DOMAIN_SERVICE_REQUEST,
  DELETE_SERVICE_DOMAIN_SERVICE_SUCCESS,
  DELETE_SERVICE_DOMAIN_SERVICE_FAIL,
  CREATE_SERVICE_DOMAIN_SERVICE_REQUEST,
  CREATE_SERVICE_DOMAIN_SERVICE_SUCCESS,
  CREATE_SERVICE_DOMAIN_SERVICE_FAIL,
  RESET_SERVICE_DOMAIN
} from '../../constants/service-domains'

const initialState = {
  loading: false,
  loadingDelete: false,
  loadingCreate: false,
  loadingUpdate: false,
  loadingDetail: false,
  serviceDomains: [],
  serviceDomain: {},
  serviceDomainService: [],
  error: null,
  pageable: {}
}

const serviceDomainReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_SERVICE_DOMAIN_REQUEST:
      return { ...state, loading: true }
    case LIST_SERVICE_DOMAIN_SUCCESS:
      return { ...state, loading: false, serviceDomains: action.payload, pageable: action.pageable }
    case LIST_SERVICE_DOMAIN_FAIL:
      return { ...state, loading: false, error: action.payload }
    case DETAIL_SERVICE_DOMAIN_SERVICE_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_SERVICE_DOMAIN_SERVICE_SUCCESS:
      return { ...state, loadingDetail: false, serviceDomainService: action.payload, pageable: action.pageable }
    case DETAIL_SERVICE_DOMAIN_SERVICE_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }
    case CREATE_SERVICE_DOMAIN_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_SERVICE_DOMAIN_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_SERVICE_DOMAIN_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case CREATE_SERVICE_DOMAIN_SERVICE_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_SERVICE_DOMAIN_SERVICE_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_SERVICE_DOMAIN_SERVICE_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_SERVICE_DOMAIN_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_SERVICE_DOMAIN_SUCCESS:
      return { ...state, loadingDetail: false, serviceDomain: action.payload }
    case DETAIL_SERVICE_DOMAIN_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }
    case UPDATE_SERVICE_DOMAIN_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_SERVICE_DOMAIN_SUCCESS:
      return { ...state, loadingUpdate: false }
    case UPDATE_SERVICE_DOMAIN_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case UPDATE_SERVICE_DOMAIN_SERVICE_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_SERVICE_DOMAIN_SERVICE_SUCCESS:
      return { ...state, loadingUpdate: false }
    case UPDATE_SERVICE_DOMAIN_SERVICE_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_SERVICE_DOMAIN_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_SERVICE_DOMAIN_SUCCESS:
      return { ...state, loadingDelete: false }
    case DELETE_SERVICE_DOMAIN_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case DELETE_SERVICE_DOMAIN_SERVICE_REQUEST: 
      return { ...state, loadingDelete: true }
    case DELETE_SERVICE_DOMAIN_SERVICE_SUCCESS:
      return { ...state, loadingDelete: false }
    case DELETE_SERVICE_DOMAIN_SERVICE_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case RESET_SERVICE_DOMAIN:
      return { ...state, loading: false, error: null }
    default:
      return state
  }
}

export default serviceDomainReducer
